<template>
  <div>
    <div class="mt-10 w-2/4 mx-auto bg-green-500">
      <product-widget></product-widget>
    </div>
    <div>
      <inc-dec
        v-model="qty"
      />
    </div>
  </div>
</template>

<script>
import ProductWidget from '@/components/ProductWidget.vue';
import IncDec from '@/components/IncDec.vue';

export default {
  data() {
    return {
      qty: 1,
    };
  },

  components:
  {
    ProductWidget,
    IncDec,
  },
};
</script>
